import type { CoverageInfo } from "@/types/payments";
import type { TransactionData } from "@/types/types";
import { paidAndLeft } from "./paymentsView";

export interface PaymentReminderRecipient {
  userId: string;
  client: string;
  plans: string[];
  amountLeft: number;
}

export function buildPaymentReminderRecipients(
  transactions: TransactionData[],
  coverageBySub: Record<string, CoverageInfo>
): PaymentReminderRecipient[] {
  const byUser = new Map<string, PaymentReminderRecipient>();

  for (const tx of transactions) {
    const subscriptionId = tx.subscriptionId;
    const coverage = subscriptionId ? coverageBySub[subscriptionId] : undefined;
    const amountLeft = paidAndLeft(tx, coverage).left;
    if (!tx.userId || amountLeft <= 0) continue;

    const existing = byUser.get(tx.userId);
    const plan = tx.description?.trim();
    if (existing) {
      existing.amountLeft += amountLeft;
      if (plan && !existing.plans.includes(plan)) existing.plans.push(plan);
      continue;
    }

    byUser.set(tx.userId, {
      userId: tx.userId,
      client: tx.client || "—",
      plans: plan ? [plan] : [],
      amountLeft,
    });
  }

  return [...byUser.values()];
}